import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@fluentui/react';
import * as React from 'react';
import { SitemapSection } from './sitemapSection';
export const SitemapSections = ({ sitemapSectionsDetails = [], refs = null })=>{
    return /*#__PURE__*/ _jsx(Stack, {
        children: sitemapSectionsDetails.map((section)=>/*#__PURE__*/ _jsx("div", {
                className: "sitemap_section_ref",
                ref: refs[section.title],
                children: /*#__PURE__*/ _jsx(SitemapSection, {
                    title: section.title,
                    rootLinkList: section.rootLinkList,
                    columns: section.columns
                }, section.title)
            }, section.title))
    });
};
